module.exports = __webpack_public_path__ + "static/media/homeAndOffice.5dfd491b.jpg";